import { CountryCode, parsePhoneNumberWithError, validatePhoneNumberLength } from 'libphonenumber-js'
import { $RootStore } from '../../src/stores/RootStore'
import { isTestMobile, isTestMobileIncomplete } from './testMobile'

export const DEFAULT_DIAL_CODE = '+44'

export type MobileInput = {
  countryCode: string
  mobileNumber: string
}

export type ValidatedMobile = {
  number: string
  country?: CountryCode
}

export const isMobileIncomplete = (store: $RootStore, phone: MobileInput): boolean => {
  const mobile = phone.countryCode + phone.mobileNumber?.trim()

  if (isTestMobileIncomplete(store.config.name, mobile)) return true

  const length = validatePhoneNumberLength(mobile)

  return length === 'TOO_SHORT' || length === 'INVALID_LENGTH' || length === 'NOT_A_NUMBER'
}

export const validateMobile = (
  store: $RootStore,
  phone: MobileInput,
  { showDropdown = true }: { showDropdown?: boolean } = {},
): ValidatedMobile | null => {
  const { i18n: { s } } = store
  const mobile = phone.countryCode + phone.mobileNumber?.trim()

  // Staging test numbers use a dial code libphonenumber rejects, and belong to no country
  if (isTestMobile(store.config.name, mobile)) return { number: mobile, country: undefined }

  let parsedNumber
  try {
    parsedNumber = parsePhoneNumberWithError(mobile)
    if (!parsedNumber.isValid()) throw new Error('Invalid number')
  } catch (e) {
    if (showDropdown) {
      store.dropdownMessageHandler.showDropdownMessage({
        type: 'error',
        title: s('Invalid phone number'),
        message: s('Please check the number and try again.'),
        closeInterval: 4000,
      })
    }
    return null
  }

  return { number: parsedNumber.number, country: parsedNumber.country }
}
